export default "__VITE_ASSET__6NQ3iGUm__"